angular.module('components.caAddressForm', [])
    .component('caAddressForm', {
        templateUrl: 'main/contacts/components/addressform.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            address: '=',
            isEditing: '<',
            onAddressUpdated: '&',
            onAddressDeleted: '&'
        },
        controller: controller
    });

// @ngInject
function controller() {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.addressUpdated = addressUpdated;
    vm.deleteAddress = deleteAddress;

    function onInit() {
        if (vm.isEditing === undefined) {
            vm.isEditing = false;
        }
    }
    function onChanges(changes) {
    }
    function onDestroy() {
    }

    function addressUpdated(address) {
        vm.address.addressLine1 = address.addressLine1;
        vm.address.addressLine2 = address.addressLine2;
        vm.address.addressLine3 = address.addressLine3;
        vm.address.postalCode = address.postalCode;
        vm.address.city = address.city;
        vm.address.country = address.country;
    }

    function deleteAddress(address) {
        vm.onAddressDeleted({address: address});
    }
}
